import React from "react";
import { motion } from "framer-motion";
import { GiftIcon, MoonIcon, GraduationCapIcon, SparklesIcon } from "lucide-react";
import { Section, Reveal, Eyebrow } from "./ui";
const bonuses = [{
  icon: MoonIcon,
  tag: "Bono 1",
  title: "Prevenir Crisis y Sobrecarga Emocional",
  desc: "Aprendé a anticipar las crisis y acompañarlas con estrategias simples y efectivas."
}, {
  icon: GraduationCapIcon,
  tag: "Bono 2",
  title: "Funciones Ejecutivas en Casa",
  desc: "Actividades fáciles para fortalecer la atención, la organización y el autocontrol."
}, {
  icon: SparklesIcon,
  tag: "Bono 3",
  title: "Rutinas para Atención y Conducta",
  desc: "Implementá rutinas claras que favorecen la autonomía y reducen el estrés diario."
}];
export function Bonuses() {
  return <Section id="bonos" className="bg-[var(--calm-blue)]/40" data-id="element-31" data-mp="1mbjn8ryt7vqn">
      <Reveal className="text-center" data-id="element-32" data-mp="1r9v0zds86qe5">
        <Eyebrow data-id="element-33" data-mp="1r8tca6iae5dy">
          <span className="inline-flex items-center gap-1.5" data-id="element-34" data-mp="1r78s9atlm4uc">
            <GiftIcon className="h-4 w-4" aria-hidden data-id="element-35" data-mp="3idemc6jw445e" /> Bonos
          </span>
        </Eyebrow>
        <h2 className="font-serif-display text-3xl font-semibold leading-tight text-[var(--ink)] sm:text-4xl" data-id="element-36" data-mp="3deadjh0vo8fl">
          Además recibís <span className="text-[var(--accent-green)]" data-id="element-37" data-mp="3r5ynperkgmtx">GRATIS</span>
        </h2>
      </Reveal>

      <div className="mt-6 grid gap-3 sm:mt-10 sm:grid-cols-3 sm:gap-5" data-id="element-38" data-mp="3n5oi437oryfl">
        {bonuses.map((b, i) => <Reveal key={b.title} delay={i * 0.08} data-id="element-39" data-mp="2zfu6foz3sfwx" data-mpi={i}>
            <motion.div whileHover={{
          y: -6
        }} transition={{
          type: "spring",
          stiffness: 300,
          damping: 20
        }} className="relative flex h-full flex-row items-center gap-3 rounded-2xl border border-[#dceee3] bg-white p-4 text-left shadow-[0_18px_50px_-30px_rgba(31,51,69,0.5)] sm:flex-col sm:items-start sm:gap-0 sm:rounded-3xl sm:p-6" data-id="element-40" data-mp="2uh0va37ah0zx">
              <span className="absolute right-5 top-5 rounded-full bg-[var(--calm-green)] px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-[var(--accent-green)]" data-id="element-41" data-mp="ir6r7tw8b86q">
                Gratis
              </span>
              <span className="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-[var(--calm-green)] text-[var(--accent-green)] sm:mb-4 sm:h-12 sm:w-12 sm:rounded-2xl" data-id="element-42" data-mp="3hgy9v9ij3gu3">
                <b.icon className="h-5 w-5 sm:h-6 sm:w-6" aria-hidden data-id="element-43" data-mp="3qj7ghoaoeq27" />
              </span>
              <div data-id="element-44" data-mp="2tsyl2f4s20i5">
                <span className="text-[10px] font-bold uppercase tracking-widest text-[var(--accent-green)] sm:text-xs" data-id="element-45" data-mp="2ttgel40220md">
                  {b.tag}
                </span>
                <h3 className="mt-0.5 font-serif-display text-base text-[var(--ink)] sm:mt-1 sm:text-lg" data-id="element-46" data-mp="32td6dehqrfln">
                  {b.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-[var(--muted)] sm:mt-2 sm:text-sm" data-id="element-47" data-mp="37l4od0mu0d06">
                  {b.desc}
                </p>
              </div>
            </motion.div>
          </Reveal>)}
      </div>
    </Section>;
}